import {Component, ElementRef, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MxConfirmDialogComponent} from '../../../../../mx-dialogs/components/mx-confirm-dialog/mx-confirm-dialog.component';
import {MxFormErrorMessageService} from '../../../../services/mx-form-error-message.service';
import {MxField} from '../../services/mxField';
import {AbstractControl} from '@angular/forms';
import {MX_TRANSLATE_SERVICE_TOKEN, MxTranslateService} from "../../../../../../shared/services/mx-translate.service";

@Component({
    selector: 'mx-file-upload-field',
    standalone: false,
    templateUrl: './mx-file-upload-field.component.html'
})
export class MxFileUploadFieldComponent extends MxField implements OnInit {

    fileName: string;
    disabled: boolean;
    private fileUploadFormControl: AbstractControl;

    @Input() public types: string;
    @ViewChild('fileInput', {static: true})
    private fileInput: ElementRef;

    constructor(public errorService: MxFormErrorMessageService, private dialog: MatDialog,
                @Inject(MX_TRANSLATE_SERVICE_TOKEN) protected translateService: MxTranslateService) {
        super(errorService, translateService);
    }

    onFileChange(files: FileList): void {
        if (files && files.length) {
            const file = files.item(0);
            if (!this.validateFileType(file.name)) {
                this.openWarningDialog('File format is not valid.')
            } else if (file.size > 1024*1024*10) {
                this.openWarningDialog('File size is too big. Maximum file size is 10MB.');
            } else {
                this.fileName = file.name;
                this.fileUploadFormControl.setValue(file);
                this.fileUploadFormControl.markAsDirty();
            }

            if (this.fileInput !== undefined && this.fileInput.nativeElement !== undefined && this.fileInput.nativeElement.value !== undefined) {
                this.fileInput.nativeElement.value = null;
            }
        }
    }

    private openWarningDialog(message: string): void {
        this.dialog.open(MxConfirmDialogComponent, {
            width: '40%',
            panelClass: 'mx-dialog-panel-class',
            data: {
                type: 'error',
                title: 'Failure',
                isAlert: true,
                message: message
            }
        });
    }

    private validateFileType(fullFileName: string): boolean {
        const availableTypes = this.types.replace(/\s/gi, '').split(',');
        return availableTypes.findIndex(value => fullFileName.toLowerCase().endsWith(value)) > -1;
    }

    ngOnInit(): void {
        this.fileUploadFormControl = this.form.controls[this.name];
        this.disabled = this.fileUploadFormControl.disabled;
    }
}
